// extracted by mini-css-extract-plugin
export var disabled = "_12-5";
export var error = "_12-1";
export var fitContent = "_12-6";
export var hasSuffix = "_12-4";
export var iconWrapper = "_12-b";
export var infoIconWrapper = "_12-d _12-b";
export var input = "_12-a";
export var inputWrapper = "_12-0";
export var large = "_12-8";
export var leadingIconWrapper = "_12-c _12-b";
export var measureBox = "_12-e";
export var medium = "_12-7";
export var readonly = "_12-2";
export var small = "_12-3";
export var suffix = "_12-9";